export default "__VITE_ASSET__CLdM9ZNR__"